const OSS = require('ali-oss');
const region = 'oss-cn-hangzhou';
const bucket = 'yyhl-mpsfile';
export const client_config = {
  region,
  bucket,
  fileHost: `http://${bucket}.${region}.aliyuncs.com/`,
}
export function client(accessKeyId, accessKeySecret,stsToken) {
  var client = new OSS({
    region,
    accessKeyId,
    accessKeySecret,
    stsToken,
    bucket,
  })  //后端提供数据
  return client
}